import { render } from "./wallets.vue?vue&type=template&id=3e5de264&scoped=true"
import script from "./wallets.vue?vue&type=script&lang=js"
export * from "./wallets.vue?vue&type=script&lang=js"

import "./wallets.vue?vue&type=style&index=0&id=3e5de264&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5de264"]])

export default __exports__